// 获取去小程序的链接
import { IDownloadListOne } from '../actions/gallery';
import request from './request';
import intl from 'react-intl-universal';

export const getToMiniProgramDownloadUrl = function(
  list: IDownloadListOne[],
  type?: string
) {
  const loc = intl.getInitOptions().currentLocale;
  // console.log(loc);
  // const isChinese = loc === 'zh-CN';
  return `pages/download/index?gallery_id=${
    window.gallery.id
  }&en_list=${encodeURIComponent(JSON.stringify(list))}&token=${
    request.token || '10086'
  }&type=${type || ''}&lang=${loc}`;
};

// 官方建议在WeixinJSBridgeReady回调中使用，请仅在需要时调用
export const isInMiniProgram = function() {
  return window.__wxjs_environment === 'miniprogram';
};
